import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
// import analytics from '@utils/analytics';
import api from '@utils/api';
import ErrorModal from '@components/error/ErrorModal';
import customEventBus from '@common/scripts/libs/eventBus';
import Icon from '@stone/ui/icon/Icon';
import analytics from '@stone/utils/analytics';
const ProductWishlistToggle = (props) => {
    const { t } = useTranslation();
    //--- STATES
    const [errorMessage, setErrorMessage] = useState();
    const [status, setStatus] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    //--- MEMO
    const currentId = useMemo(() => {
        var _a, _b;
        return (((_a = props.productColor) === null || _a === void 0 ? void 0 : _a.productId) || '') + (((_b = props.productSize) === null || _b === void 0 ? void 0 : _b.id) || '');
    }, [props.productColor, props.productSize]);
    //--- EFFECTS
    useEffect(() => {
        const updateFunction = (data) => {
            setStatus(!!data.wishlistIds.find((pid) => pid.includes(currentId)));
        };
        customEventBus.on('wishlist:update', updateFunction);
        return () => {
            customEventBus.off('wishlist:update', updateFunction);
        };
    }, [currentId]);
    useEffect(() => {
        const updatedStatus = !!window.wishlistIds.find((pid) => pid.includes(currentId));
        if (updatedStatus !== status) {
            setStatus(updatedStatus);
            setIsLoading(false);
        }
    }, [currentId]);
    //--- METHODS
    const toggleWishlist = () => {
        setIsLoading(true);
        if (status) {
            api
                .removeFromWishlist(currentId)
                .then((data) => {
                if (data.success) {
                    if (data.items) {
                        setStatus(!!data.items.find((pid) => pid.includes(currentId)));
                        customEventBus.emit('account:update', { wishlistIds: data.items });
                        customEventBus.emit('wishlist:update', { wishlistIds: data.items });
                        // console.info('[wishlist:update] emit from product: ', currentId, ', count: ', data.items.length);
                    }
                }
                else {
                    setErrorMessage(data.errorMsg);
                    props.setErrorMessage(data.errorMsg);
                }
                setIsLoading(false);
            })
                .catch((res) => setErrorMessage(res));
        }
        else {
            api
                .addToWishlist(currentId)
                .then((data) => {
                if (data.success) {
                    if (data.items) {
                        setStatus(!!data.items.find((pid) => pid.includes(currentId)));
                        customEventBus.emit('account:update', { wishlistIds: data.items });
                        customEventBus.emit('wishlist:update', { wishlistIds: data.items });
                        // console.info('[wishlist:update] emit from product: ', currentId, ', count: ', data.items.length);
                        // analytics.saveForLaterAddToWishlist(props.product as any as models.Product, props?.productSize?.id);
                        // analytics.wishlistInteraction(props.product?.masterId, props.section);
                        analytics.addToWishlist(props.product.id);
                    }
                }
                else {
                    setErrorMessage(data.errorMsg);
                    props.setErrorMessage(data.errorMsg);
                }
                setIsLoading(false);
            })
                .catch((res) => setErrorMessage(res));
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { "aria-label": t('button.saveforlater'), className: 'button wishlist-icon' + (props.modifierClass || ''), "aria-pressed": status, onClick: toggleWishlist, "aria-busy": isLoading, "data-color": props.color, tabIndex: props.disableFocus ? -1 : undefined },
            React.createElement(Icon, { family: "16", name: !status ? 'save' : 'save-selected', ariaHidden: true })),
        React.createElement(ErrorModal, { message: errorMessage, onClose: () => setErrorMessage(undefined) })));
};
export default ProductWishlistToggle;
